var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mainDiv"},[_c('div',{staticClass:"header"}),_c('div',{staticClass:"content"},[_c('P',[_vm._v("ご予約をキャンセルしました。")])],1),_c('div',{staticClass:"foot"},[_c('router-link',{attrs:{"to":"/"}},[_vm._v("閉じる")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }